export default __webpack_public_path__ + "media/images/plus-abb5fb19d85367d9541dc28f44d7fa58.svg";